<template>
  <b-modal :id="id" title="Sichtbare Spalten wählen" body-class="p-0" @ok="$emit('ok')">
    <b-list-group style="max-height: calc(100svh - 250px); overflow-y: auto">
      <b-list-group-item
        class="border-top-0 border-left-0 border-right-0"
        v-for="item in fields.filter(x => x.hideable && x.label !== '')"
        :key="item.key"
      >
        <b-form-checkbox
          v-model="item.visible"
          :value="true"
          :unchecked-value="false"
          @update="AppState.updateVisibleFields(id, fields)"
        >
          {{ item.label }}
        </b-form-checkbox>
      </b-list-group-item>
    </b-list-group>
  </b-modal>
</template>

<script>
import AppState from '@/store/App.js';
export default {
  data() {
    return {
      AppState
    };
  },
  props: {
    fields: {
      type: Array
    },
    id: {
      type: String
    }
  }
};
</script>

<style></style>
